module.exports = __webpack_public_path__ + "img/flag_it.e01d3a93.png";